import styled from 'styled-components';

const ItemGroup = styled.div`
  display: flex;
`;

export default ItemGroup;



// WEBPACK FOOTER //
// ./components/QuickActionBar/ItemGroup.js